import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontTarifs from './tarifs';
import FrontTarifsAlone from './tarifsAlone';
import FrontOptions from './options'
import FrontOptionsAlone from './optionsAlone'
import FrontProgress from './progress';
import FrontEcheancier from './echeancier';
import DataDevis from '../dataDevis';
import UserReviews from './userReviews';
import abp from '../img/ABP.png'
import img_horloge from '../img/Horloge.svg'
import FrontPeriodicite from './periodicite';
import FrontRecap,{CbLogos} from './recap';
import echeancier from '../img/échéancier.svg'
import arrow_down from '../img/black_arrow_down.png'
import arrow_up from '../img/black_arrow_up.png'
import woman from '../img/femme.png'
import RecapUnfoldVehicule from './recapUnfoldVehicule';
import RecapUnfoldYou from './recapUnfoldYou';

export default class FrontLanding extends React.Component {
    
    constructor(props) {
        super(props);
        this.refRecap = React.createRef()
        this.state = {
            collapseEcheancier:true
        }
    }

    onSubmit() {
        this.props.setPage('details1')
    }

    goToRecap() {
        this.refRecap.current?.scrollIntoView({behavior:'smooth'})
    }

    componentDidMount() {
        this.componentDidUpdate()
    }

    componentDidUpdate() {
        if ( ! this.props.devis.validated ) {
            this.props.validateDevis()
        }
    }



    render() {
        const devis = this.props.devis
        const params = devis.params
        const solly = devis.getSolly()
        const oneColumn = ! solly.hasSolly()
        const container = {
            solly:solly,
            oneColumn:oneColumn,
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage,
            focusError: ()=>{}
        }
        console.log(container)
/*
        const toPay = devis.toPay()
        const toPayYearly = devis.toPayYearly()
        const selectedOptions = devis.getValue('selectedOptions',[])
        const periodicite = devis.getValue('periodicite')
*/
        const subscribeButton = this.props.enableClientSubscription
        ?<p>
            <a className="button button_subscribe" onClick={()=>this.props.setPage('details1')}>
                Souscrivez en ligne en 2&nbsp;minutes&nbsp;<span>▸</span>
            </a>
        </p>
        :<><a className="button button_subscribe">La souscription en ligne est temporairement fermée.</a></>
        const subscribeButtonShort = this.props.enableClientSubscription
        ?<a className="button button_devis yellow" onClick={()=>this.props.setPage('details1')}>
            Souscrire&nbsp;<span>▸</span>
        </a>
        :<></>

        return <>
        <FrontProgress onSubmit={this.onSubmit.bind(this)} comparateursCompleted={params.comparateursCompleted} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className="container narrow">
            <div className="contentbox front_form">
                <div className="contentvbox">
                    {this.props.enableClientSubscription?'':<><br/>{subscribeButton}<p>N'hésitez pas à nous contacter au <br/><a href="tel:0974772861">09 74 77 28 61</a></p></>}
                    {oneColumn?<>
                        <h2>Choisissez votre <b>formule</b> et votre fréquence de paiement</h2>
                        <FrontTarifsAlone container={container}/>
                        {params.options ? <h2>Choisissez vos options</h2> : ''}
                        <FrontOptionsAlone container={container}/>


                    </>:<>
                        <h2>Je souhaite <b>régler</b> en&nbsp;:</h2>
                        <FrontPeriodicite container={container}/>
                        <h2>Comparez nos offres & choisissez votre <b>formule</b></h2>
                        <FrontTarifs container={container}/>
                        {params.options ? <h2>Choisissez vos options</h2> : ''}
                        <FrontOptions container={container}/>
                    </>}
                    
                </div>
                <div className="contentvbox">

                {oneColumn?<>

                    <h1>Détails de mes garanties et mes options</h1>

                    <div className="prices onecolumn">
                        <h3>Votre Tarif</h3>


                            {(params.periodicite=='M')?<>
                                <b>{devis.toPayMonthly()}</b> par mois<br/>
                                <b>{devis.toPayYearly()}</b> par an TTC*<br/>
                            </>:<>
                                <b>{devis.toPayYearly()}</b> par an TTC*<br/>
                            </>}
                            * Frais de gestion et courtage inclus

                            <button
                                className="subscribe"
                                onClick={()=>this.props.setPage('details1')}>Souscrire cette offre</button>
                            <CbLogos/>
                            <button 
                                className="receive_devis"
                                onClick={()=>this.props.setPage('receive')}
                                >Enregistrer<br/>&<br/>Recevoir mon devis</button>

                                {(params.periodicite=='M')?<p>
                                * L'acompte de <b>{devis.toPay()} €</b> inclut les frais de gestion et de
                                courtage ainsi que les deux premiers mois. Puis, par mois, à
                                partir du 3ème mois : <b>{devis.toPayMonthly()} €</b></p>:<></>}
                    </div>
                </>:<>
                
                    <h1>Choisissez votre offre & souscrivez</h1>
                    <h4>Bonne nouvelle ! Il ne vous reste plus que <b><img src={img_horloge}/> 1 minute</b> afin de souscrire votre véhicule</h4>

                    <FrontRecap devis={container.devis} setPage={this.props.setPage}/>

                </>}

                    <h2 className="clickbox"
                        onClick={()=>this.setState(state=>({collapseEcheancier:!state.collapseEcheancier}))}
                    >
                        <img src={echeancier}/> 
                        Votre <b>échéancier</b>
                        <img className="right_switch" src={this.state.collapseEcheancier ? arrow_down : arrow_up}/>
                    </h2>

                    <FrontEcheancier container={container} hidden={this.state.collapseEcheancier}/>

                    <div className="notice_woman_box">
                        <div>
                            <b>À noter !</b> Le paiement annuel est effectué en <i>une seule fois</i>. En revanche, le
                            paiement mensuel comprend un <i>versement initial</i> lors de la souscription,
                            incluant <i>un mois d'assurance</i> ainsi que les <i>frais de gestion et de courtage,</i>
                            suivis de onze prélèvements mensuels. Les frais de gestion et de courtage
                            sont <i>renouvelables et non remboursables</i>.
                        </div>
                        <div>
                            <img src={woman}/>
                        </div>
                    </div>
                </div>

                <div className="recap_unfold_container">
                    <RecapUnfoldYou devis={devis} setPage={this.props.setPage}/>
                    <RecapUnfoldVehicule devis={devis} setPage={this.props.setPage}/>
                </div>

            </div>


            </div>

        </>
    }
}